import { render, staticRenderFns } from "./PathwayViewUserPermissionsCard.vue?vue&type=template&id=10f24084&"
import script from "./PathwayViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./PathwayViewUserPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports